import { Badge } from "@/components/ui/badge";
import { Building2, Link2, Briefcase, Handshake, Users } from "lucide-react";
import { extractStructureState, canHaveFilials, isFilial, isSubsidiaria } from "@/types/structure";

interface CompanyStatusBadgesProps {
  company: any;
}

/**
 * CompanyStatusBadges
 * Exibe chips de status da empresa (Matriz, Filial, Controladora, Membro do Grupo)
 * 
 * Chips exibidos:
 * - [Matriz] se isMatriz = true
 * - [Filial] se matrizId != null
 * - [Controladora] se isControladora = true
 * - [Membro do Grupo] se controladoraId != null
 */
export default function CompanyStatusBadges({ company }: CompanyStatusBadgesProps) {
  const state = extractStructureState(company);
  
  const badges = [];

  // Matriz
  if (state.isMatriz) {
    badges.push(
      <Badge key="matriz" variant="outline" className="gap-1">
        <Building2 className="h-3 w-3" />
        Matriz
      </Badge>
    );
  }

  // Filial
  if (isFilial(company)) {
    badges.push(
      <Badge key="filial" variant="secondary" className="gap-1">
        <Link2 className="h-3 w-3" />
        Filial
      </Badge>
    );
  }

  // Controladora
  if (state.isControladora) {
    badges.push(
      <Badge key="controladora" variant="outline" className="gap-1">
        <Briefcase className="h-3 w-3" />
        Controladora
      </Badge>
    );
  }

  // Membro do Grupo
  if (isSubsidiaria(company)) {
    badges.push(
      <Badge key="membro" variant="secondary" className="gap-1">
        <Link2 className="h-3 w-3" />
        Membro do Grupo
      </Badge>
    );
  }

  // V11: Representante
  if (company.isRepresentative) {
    badges.push(
      <Badge key="representante" variant="outline" className="gap-1 border-green-300 text-green-700 bg-green-50">
        <Handshake className="h-3 w-3" />
        Representante
      </Badge>
    );
  }

  // V11: Via Representante
  if (company.salesType === "REPRESENTATIVE" && company.representativeCompanyId) {
    badges.push(
      <Badge key="via-rep" variant="secondary" className="gap-1 bg-purple-50 text-purple-700">
        <Users className="h-3 w-3" />
        Via Representante
      </Badge>
    );
  }

  // Se não tem nenhum status especial
  if (badges.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2">
      {badges}
    </div>
  );
}
